module.exports = __webpack_public_path__ + "img/healthy_page05_img1.d57b43b4.png";